import {DestroyRef, Injectable} from '@angular/core';
import {NgEventBus} from 'ng-event-bus';
import {LookupService} from './lookup.service';
import {PlanModelService} from './plan-model.service';
import {UiConfiguration} from '../models/ui-configuration.model';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Injectable({
    providedIn: 'root'
})
export class UiConfigurationService {
    title = 'UiConfiguration Service';
    infoUiGroups: UiConfiguration[] = [];
    planPurposeLookups = [];

    constructor(
        private eventBus: NgEventBus,
        private lookupService: LookupService,
        private planModelService: PlanModelService,
        private destroyRef: DestroyRef
    ) {}

    populateInfoUiGroups() {
        console.debug(this.title + ' populateInfoUiGroups');
        if (this.lookupService.lookupsLoaded) {
            this.initialiseLookups();
        } else {
            this.eventBus
                .on('nlr:lookups-loaded')
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe(() => {
                    this.initialiseLookups();
                });
        }
    }

    private initialiseLookups() {
        this.infoUiGroups = this.lookupService.getLookups('infoUiGroupDisplay');
        this.planPurposeLookups = this.lookupService.getLookups('planPurpose');
    }

    getModel() {
        return this.planModelService.getModel();
    }

    getInfoUiGroup() {
        return this.infoUiGroups.find(l => this.getModel().planPurpose?.id === l.planPurposeCode);
    }

    uiGroupsSetup() {
        console.debug(this.title + ' uiGroupsSetup : ' + this.planPurposeLookups);
        const result = {
            infoUiGroups: undefined,
            planPurposeLookup: undefined
        };

        if (this.planPurposeLookups !== undefined && this.infoUiGroups !== undefined) {
            this.infoUiGroups.forEach(model => {
                if (model.active && this.getModel().planPurpose !== undefined && this.getModel().planPurpose.id === model.planPurposeCode) {
                    result.infoUiGroups = model;
                }
            });

            this.planPurposeLookups.forEach(model => {
                if (model.active && this.getModel().planPurpose !== undefined && this.getModel().planPurpose.id === model.id) {
                    result.planPurposeLookup = model;
                }
            });

            this.showGroupsByUiInfoModel(result);
        } else {
            this.showGroupsByUiInfoModel();
        }
        return result;
    }

    isRoadsDisplayed(model) {
        return (
            model.planPurposeLookup.privateRoadQuestion ||
            model.planPurposeLookup.roadClosureQuestion ||
            model.planPurposeLookup.roadWideningQuestion ||
            model.planPurposeLookup.roadNameApprovalQuestion ||
            model.planPurposeLookup.roadNameApprovalExemptQuestion ||
            model.planPurposeLookup.lgaApprovedUnnamedRoadQuestion
        );
    }

    showGroupsByUiInfoModel(model?) {
        console.log(model);
        // $log.debug(this.title + ' showGroupsByUiInfoModel');
        //
        // $('section.right .information-content .group').hide();
        // $('surveyor-details.group').show();
        // $('plan-details.group').show();
        //
        // if (angular.isDefined(model) && angular.isDefined(model.planPurposeLookup) && angular.isDefined(model.infoUiGroups)) {
        //
        //     if (model.infoUiGroups.surveyorDetailsDisplay) {
        //         $('surveyor-details.group').show();
        //     }
        //
        //     if (model.planPurposeLookup.planDetailsDisplay) {
        //         $('plan-details.group').show();
        //     }
        //
        //     if (model.infoUiGroups.surveyDetailsDisplay) {
        //         $('survey-details.group').show();
        //     }
        //
        //     if (model.planPurposeLookup.parentTenureAssociationType) {
        //         $('former-tenure.group').show();
        //     }
        //
        //     if (model.planPurposeLookup.fieldRecordsDisplay) {
        //         $('field-record.group').show();
        //     }
        //
        //     if (vm.isRoadsDisplayed(model)) {
        //         $('road.group').show();
        //     }
        //
        //     if (model.infoUiGroups.strataSchemeDetailsDisplay) {
        //         $('strata-schema-details.group').show();
        //     }
        //
        //     if (model.infoUiGroups.strataSchemeModificationDisplay) {
        //         //TODO reneable in later release
        //         //$('strata-schema-modification.group').show();
        //     }
        //
        //     if (model.infoUiGroups.crownStateLandDisplay) {
        //         $('crown-state-land.group').show();
        //     }
        //
        //     if (model.infoUiGroups.localityLgaDisplay) {
        //         $('locality-and-lga.group').show();
        //     }
        //
        //     if (model.infoUiGroups.planCancellationDisplay) {
        //
        //     }
        //
        //     if (model.infoUiGroups.unapprovedPlansDisplay) {
        //
        //     }
        //
        //     if (model.infoUiGroups.schemeParcelAddress) {
        //
        //     }
    }

    broadcastVisibility(model) {
        console.debug(model);
    }
    //     this
    // .
    //     broadcastVisibility = function (model) {
    //         var visibilityEvent = {
    //
    //             surveyorDetails: angular.isDefined(model) && angular.isDefined(model.infoUiGroups) ?
    //                 model.infoUiGroups.surveyorDetailsDisplay : false,
    //             planDetails: angular.isDefined(model) && angular.isDefined(model.planPurposeLookup) ?
    //                 model.planPurposeLookup.planDetailsDisplay : false,
    //             surveyDetails: angular.isDefined(model) && angular.isDefined(model.infoUiGroups) ?
    //                 model.infoUiGroups.surveyDetailsDisplay : false,
    //             formerTenure: angular.isDefined(model) && angular.isDefined(model.planPurposeLookup) ?
    //                 model.planPurposeLookup.parentTenureAssociationType : false,
    //             fieldRecords: angular.isDefined(model) && angular.isDefined(model.planPurposeLookup) ?
    //                 model.planPurposeLookup.fieldRecordsDisplay : false,
    //             privateRoadQuestion: angular.isDefined(model) && angular.isDefined(model.planPurposeLookup) ?
    //                 model.planPurposeLookup.privateRoadQuestion : false,
    //             roadClosureQuestion: angular.isDefined(model) && angular.isDefined(model.planPurposeLookup) ?
    //                 model.planPurposeLookup.roadClosureQuestion : false,
    //             roadWideningQuestion: angular.isDefined(model) && angular.isDefined(model.planPurposeLookup) ?
    //                 model.planPurposeLookup.roadWideningQuestion : false,
    //             roadNameApprovalQuestion: angular.isDefined(model) && angular.isDefined(model.planPurposeLookup) ?
    //                 model.planPurposeLookup.roadNameApprovalQuestion : false,
    //             roadNameApprovalExemptQuestion: angular.isDefined(model) && angular.isDefined(model.planPurposeLookup) ?
    //                 model.planPurposeLookup.roadNameApprovalExemptQuestion : false,
    //             lgaApprovedUnnamedRoadQuestion: angular.isDefined(model) && angular.isDefined(model.planPurposeLookup) ?
    //                 model.planPurposeLookup.lgaApprovedUnnamedRoadQuestion : false,
    //             strataSchemeDetails: angular.isDefined(model) && angular.isDefined(model.infoUiGroups) ?
    //                 model.infoUiGroups.strataSchemeDetailsDisplay : false,
    //             strataSchemeModification: angular.isDefined(model) && angular.isDefined(model.infoUiGroups) ?
    //                 model.infoUiGroups.strataSchemeModificationDisplay : false,
    //             crownStateLand: angular.isDefined(model) && angular.isDefined(model.infoUiGroups) ?
    //                 model.infoUiGroups.crownStateLandDisplay : false,
    //             localityLga: angular.isDefined(model) && angular.isDefined(model.infoUiGroups) ?
    //                 model.infoUiGroups.localityLgaDisplay : false,
    //             planCancellation: angular.isDefined(model) && angular.isDefined(model.infoUiGroups) ?
    //                 model.infoUiGroups.planCancellationDisplay : false,
    //             unapprovedPlans: angular.isDefined(model) && angular.isDefined(model.infoUiGroups) ?
    //                 model.infoUiGroups.unapprovedPlansDisplay : false,
    //             schemeParcelAddress: angular.isDefined(model) && angular.isDefined(model.infoUiGroups) ?
    //                 model.infoUiGroups.schemeParcelAddress : false,
    //             subjectOfPlan: angular.isDefined(model) ? model.enableSubjectOfPlan : false
    //         };
    //
    //         if (!angular.equals(visibilityEvent, this.lastVisibilityEvent)) {
    //             $rootScope.$broadcast('visibilityChange', visibilityEvent);
    //         }
    //
    //         this.lastVisibilityEvent = visibilityEvent;
    //     }.bind({lastVisibilityEvent: {}});
}
